import React from 'react';

interface PlanCardSkeletonProps {
  count?: number;
  type?: 'active' | 'pending' | 'completed' | 'cancelled';
}

const PlanCardSkeleton: React.FC<PlanCardSkeletonProps> = ({
  count = 3,
  type = 'active',
}) => {
  // Simplified skeleton for pending plans
  if (type === 'pending') {
    return (
      <>
        {[...Array(count)].map((_, index) => (
          <div
            key={index}
            className="rounded-[5px] border border-gray-200 bg-white p-4 animate-pulse"
          >
            <div className="flex justify-between items-start mb-3">
              <div className="h-5 bg-gray-200 rounded w-32"></div>
              <div className="h-5 bg-gray-200 rounded w-20"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-full"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
        ))}
      </>
    );
  }

  // Full skeleton for other plan types
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <div
          key={index}
          className="p-4 border border-gray-200 rounded-md shadow-sm animate-pulse"
        >
          {/* Header with title and amount */}
          <div className="flex justify-between items-start lg:items-center mb-3 flex-col lg:flex-row">
            <div className="h-5 bg-gray-200 rounded w-40 mb-2 lg:mb-0"></div>
            <div className="flex items-center gap-2">
              <div className="h-5 bg-gray-200 rounded w-24"></div>
              <div className="h-4 w-4 bg-gray-200 rounded-full"></div>
            </div>
          </div>

          {/* Paid and Remaining amounts */}
          <div className="flex justify-between items-center mb-2">
            <div className="h-4 bg-gray-200 rounded w-28"></div>
            <div className="h-4 bg-gray-200 rounded w-28"></div>
          </div>

          {/* Progress bar */}
          <div className="mt-2">
            <div className="h-2 w-full bg-gray-200 rounded-full"></div>
            <div className="h-3 bg-gray-200 rounded w-32 mt-2"></div>
          </div>

          {/* View EPP button */}
          <div className="mt-4">
            <div className="h-5 bg-gray-200 rounded w-24"></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default PlanCardSkeleton;
